import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProfileDataService } from '../services/data/profile-data.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProfileComponent {
  protected readonly employeeInformation$ = toSignal(
    this.profileDataService.employeeInformation$,
    { initialValue: null },
  );
  protected readonly loading$ = signal(false);

  constructor(
    private readonly profileDataService: ProfileDataService,
    private readonly snackBar: MatSnackBar,
  ) {
    this.refreshEmployeeInformation();
  }

  newAvatarSelected(event: Event) {
    if (event.target) {
      const eventTarget = event.target as HTMLInputElement;
      if (eventTarget.files) {
        if (eventTarget.files.length !== 1) {
          this.snackBar.open(
            $localize`Bitte wähle nur ein Bild als deinen Avatar aus.`,
            undefined,
            { duration: 5_000 },
          );
          return;
        }

        const uploadSnackbarRef = this.snackBar.open(
          $localize`Lade neuen Avatar hoch...`,
        );

        this.profileDataService.uploadAvatar(eventTarget.files[0]).subscribe({
          error: () => {
            uploadSnackbarRef.dismiss();
            this.snackBar.open(
              $localize`Datei konnte nicht hochgeladen werden.`,
              undefined,
              {
                duration: 5_000,
              },
            );
          },
          complete: () => {
            uploadSnackbarRef.dismiss();
          },
        });
      }
    }
  }

  private refreshEmployeeInformation(): void {
    this.loading$.set(true);
    this.profileDataService.loadProfileData().subscribe({
      next: () => {
        this.loading$.set(false);
      },
      error: () => {
        this.loading$.set(false);
      },
    });
  }
}
